import { render, staticRenderFns } from "./NewController.vue?vue&type=template&id=b76dad7c"
import script from "./NewController.vue?vue&type=script&lang=js"
export * from "./NewController.vue?vue&type=script&lang=js"
import style0 from "./NewController.vue?vue&type=style&index=0&id=b76dad7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports